define([
	"dojo/_base/declare",
	"csi",
	"csi/reflection",
	"csi/xml"
], function(declare,csi,reflection,xml) {

	return declare(null, {
		_initSourceObjectFormFields: function(/*csi.view.Widget*/formView, /*Node*/sourceObject) {
			formView.cacheView.cacheNode(sourceObject);
			formView.addDefaultValue("SourceType", "CDocSourceType:Object");
			formView.addDefaultValue("SourceObjectType", "CDocSourceObjectType:" + sourceObject.$Type);
			formView.addDefaultValue("SourceObjectRevision", sourceObject.$URL);
		},

		_adjustSaveScript: function(/*String*/urlNode, /*FormData?*/fd) {
			// summary: special handling for source fields
			fd = this.m_formData;

			// despite the name, SourceObjectRevision is selected as the source-object master; send the rev instead
			var sourceObjectUrl = fd.getFieldValue("SourceObjectRevision", true);
			if (sourceObjectUrl && sourceObjectUrl != csi.EMPTY_URL) {
				var sourceObjectRevisionUrl = this.m_cache.getNode(sourceObjectUrl, true).CurrentRevision;
				this.m_writer.changeNode(xml.getUrlPath(urlNode, reflection.PATH_CURRENT_REVISION))
					.changeAttribute("SourceObjectRevision", xml.ATTR_REF, sourceObjectRevisionUrl)
					.changeAttributeFlag("SourceObjectRevision", xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
			}

			// special change-node script for web-doc fields
			var linkUrl = fd.getFieldValue("SourceWebURL", true);
			if (linkUrl) {
				var linkName = fd.getFieldValue("CDocSourceWebName", true);
				if (linkName == "")
					linkName = "Link";
				this.m_writer.changeNode(xml.getUrlPath(urlNode, reflection.PATH_CURRENT_REVISION))
					.changeAttribute("SourceWebURL", xml.ATTR_STRING, linkName + ":" + linkUrl)
					.changeAttributeFlag("SourceWebURL", xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
			}
		}
	});
});
